import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=2e4a4034&scoped=true&lang=html&"
import script from "./NavigationHeader.vue?vue&type=script&lang=js&"
export * from "./NavigationHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHeader.vue?vue&type=style&index=0&id=2e4a4034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a4034",
  null
  
)

export default component.exports